import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export function PWAUpdatePrompt() {
  const [needRefresh, setNeedRefresh] = useState(false);
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    // Listen for SW update events dispatched from main.tsx
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setNeedRefresh(true);
      setRegistration(detail?.registration ?? null);
    };
    window.addEventListener('nudge:sw-update', handler);
    return () => window.removeEventListener('nudge:sw-update', handler);
  }, []);

  const handleUpdate = () => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      setNeedRefresh(false);
      window.location.reload();
    }
  };

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 animate-in slide-in-from-bottom">
      <div className="bg-slate-900 text-white rounded-2xl p-4 shadow-2xl flex items-center gap-3">
        <div className="size-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
          <RefreshCw size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold">Update available</p>
          <p className="text-xs text-slate-400">A new version of Nudge is ready.</p>
        </div>
        <button
          onClick={handleUpdate}
          className="px-4 py-2 bg-[#fa8585] rounded-xl text-sm font-bold flex-shrink-0 active:scale-95 transition-transform"
        >
          Update
        </button>
      </div>
    </div>
  );
}
